module.exports = __webpack_public_path__ + "static/media/reset_icon.297a1439.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/reset_icon.png
// module id = 2254
// module chunks = 0